<template>
  <div class="app-container">
    <div class="index-tree-box">
      <type-tree ref="type_tree" show-action @on-select="onSelect" @title-click="titleClick" />
      <div class="right-box">
        <list ref="list">
          <template slot="toolbar-right" v-if="$permission.canWrite()">
            <el-button type="success" plain @click="onImport">导入</el-button>
            <el-button type="success" @click="onExport">导出</el-button>
            <el-button type="primary" @click="create" icon="el-icon-plus">添加</el-button>
            <el-button type="danger" @click="delRows">删除</el-button>
          </template>
          <template slot="column" v-if="$permission.canWrite()">
            <el-table-column label="操作" fixed="right" align="center" width="80">
              <template slot-scope="{ row }">
                <el-button type="text" @click="edit(row)">编辑</el-button>
              </template>
            </el-table-column>
          </template>
        </list>
      </div>
    </div>
    <edit-dialog ref="editDialog" @close-saved="reload1" />
    <import-dialog ref="importDialog" @upload-success="reload1" />
  </div>
</template>
<script>
import curdMixins from '@/mixins/trend/curd'
import list from '@/components/basedata/personnel/dp/list'
import editDialog from '@/components/basedata/personnel/dp/editDialog'
import typeTree from '@/components/basedata/personnel/dp/tree'
import importDialog from '@/components/basedata/personnel/dp/importDialog'

export default {
  name: 'dp',
  mixins: [curdMixins],
  components: {
    list,
    editDialog,
    typeTree,
    importDialog
  },
  data() {
    return {
      select: {
        Id: null,
        Name: '',
        Pid: null
      }
    }
  },
  mounted() {
    this.$refs.type_tree.getData()
  },
  methods: {
    reload1() {
      this.reload()
      this.$refs.type_tree.getData()
    },
    edit(row) {
      console.log(row, 'row')
      this.$refs.editDialog.openEdit(row)
    },
    onImport() {
      this.$refs.importDialog.open()
    },
    onExport() {
      this.$confirm('是否导出数据？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$refs.list.onExport()
        })
        .catch(() => {})
    },
    onSelect(data) {
      // console.log("onSelect", data);
      this.select.Id = data.DpId
      this.select.Name = data.DpName
      this.select.Pid = Boolean(data.Pid) ? data.Pid : null
      this.$refs.list.getData({ IdChain: data.IdChain })
      // this.reload();
    },
    titleClick() {
      console.log(2)
      this.select.Id = null
      this.select.Name = ''
      this.select.Pid = null
      this.$refs.list.getData({ IdChain: null })
    },
    create() {
      console.log(3)
      this.$refs.editDialog.openCreate({
        DpId: this.select.Id,
        DpName: this.select.Name,
        Pid: this.select.Pid
      })
    },
    delRows() {
      let rows = this.$refs.list.getCheckedRows()
      if (rows.length == 0) {
        this.$message.warning('请选择要删除的数据')
        return
      }
      this.$confirm('确认删除所选的数据吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let ids = rows.map(item => {
            return item.DpId
          })
          this.$refs.list.delRange(ids)
        })
        .catch(() => {})
    }
  }
}
</script>